<template>
  <PageLayout
    class="history-page"
    :style="{ maxWidth: computedMaxWidth + 'px' }"
  >
    <PageTitle class="page-title">Історія замовлень</PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    <History />
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import History from '../../views/history';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";

export default {
  data() {
    return {
      breadcrumbs: [
        {
          title: 'Головна',
        },
        {
          title: 'Історія замовлень',
        },
      ],
    }
  },
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, PageTitle, History, Breadcrumbs },
  computed: {
    ...mapGetters('layoutModule', ['isTablet', 'isMobile', 'windowWidth']),
    computedMaxWidth() {
      if (this.isTablet || this.isMobile) {
        return this.windowWidth;
      }

      return this.windowWidth; //- 160;
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  //margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}

::v-deep .list-orders .tabs-block .status-tabs .tab + .tab {
  margin-left: 70px;
}

@media (max-width: 1220px) and (min-width: 992px) {
  ::v-deep .list-orders .tabs-block {
    max-width: none;
    width: auto;
  }
}
</style>
